import React from 'react';
import { Button } from "@/components/ui/button";
import { Brain, Bookmark } from "lucide-react";
import { ChatMessage } from "../../ChatMessage";
import { Message } from './types';

interface ChatMessagesProps {
  messages: Message[];
  isLoading: boolean;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  onDeleteMessage: (messageId: string, dbId?: string) => void;
  onSaveInsight: (text: string) => void;
}

export const ChatMessages: React.FC<ChatMessagesProps> = ({
  messages,
  isLoading,
  messagesEndRef,
  onDeleteMessage,
  onSaveInsight
}) => {
  return (
    <div className="flex-1 overflow-y-auto p-6 space-y-4 min-h-[400px]">
      {isLoading ? (
        <div className="flex justify-center items-center py-8">
          <Brain className="h-6 w-6 animate-pulse text-primary" />
          <span className="ml-2 text-muted-foreground">Loading conversation...</span>
        </div>
      ) : (
        messages.map((message) => (
          <div key={message.id} className="space-y-2">
            <ChatMessage 
              message={message.text} 
              isUser={message.isUser} 
              timestamp={message.timestamp} 
              onDelete={() => onDeleteMessage(message.id, message.dbId)}
              messageId={message.id}
            />
            {!message.isUser && message.text.length > 100 && (
              <div className="flex justify-start ml-4">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onSaveInsight(message.text)}
                  className="gap-2 text-xs"
                >
                  <Bookmark className="h-3 w-3" />
                  Save Insight
                </Button>
              </div>
            )}
          </div>
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};
